import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import aiInsights from 'modules/enps/store/collections/aiInsights'
import type AIInsightsData from 'modules/enps/store/models/AIInsights'
import { Cycle } from 'modules/enps/store/models/AnalyticResult'

import { useAnalytics } from 'modules/enps/pages/AnalyticsPage/useAnalytics'
import AiInsaightsTable from './AiInsaightsTable'

const InsightsAI = () => {
  const { form, cycle, loading } = useAnalytics()
  const [insights, setInsights] = useState<AIInsightsData>()

  const getData = useCallback(
    async (cycle: Cycle | null) => {
      if (!cycle) return null

      const [cycle_start_on, cycle_end_on] = cycle

      const response = await aiInsights.fetch({
        data: {
          enps_form_id: form.id,
          cycle_start_on,
          cycle_end_on,
        },
      })

      return response
    },
    [form.id]
  )

  useUnsafeEffect(() => {
    const fetchData = async () => {
      const fetchedData = await getData(cycle)
      setInsights(fetchedData)
    }

    fetchData()
  }, [getData, cycle])

  return insights ? (
    <Box gap="s24" flexDirection="row">
      <AiInsaightsTable
        insightsList={insights.detractors}
        title={i18n.t('enps.analytics.people_mentions.titles.dislike')}
      />
      <AiInsaightsTable
        insightsList={insights.promoters}
        title={i18n.t('enps.analytics.people_mentions.titles.like')}
      />
    </Box>
  ) : null
}

export default observer(InsightsAI)
